import React from 'react';
import toast from 'react-hot-toast';
import styled from 'styled-components';

import { useGlobalModalContext } from '../../context/GlobalModal';
import { useForm } from '../../hooks';
import { Button, Input, Modal } from '../../shared/Components';
import { Text } from '../../shared/Typhography';
import { strings } from '../../strings';
import { editColoringGridCollection } from '../../services/api/colloringGridCollectionApi';
import {
  EditColoringGridCollectionField,
  editColoringGridCollectionSchema,
} from '../../validations/editColoringGridCollection';

const AdminOnlyWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;

  & > div {
    width: 30px;
    max-width: 30px;
  }

  & > div > div {
    width: 30px;
    max-width: 30px;

    & > input {
      width: 30px;
      max-width: 30px;
    }
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 50px;
  gap: 32px;
`;

interface EditCollectionForms {
  [EditColoringGridCollectionField.Name]: string;
  [EditColoringGridCollectionField.AdminOnly]: boolean;
}

const EditColoringGridCollectionModal = () => {
  const { hideModal, store } = useGlobalModalContext();
  const { modalProps } = store || {};
  const { title, collection: category } = modalProps || {};
  const { mutate: edit } = editColoringGridCollection(category.firebaseId);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<EditCollectionForms>({
    schema: editColoringGridCollectionSchema(category.firebaseId),
    defaultValues: {
      [EditColoringGridCollectionField.Name]: category.name,
      [EditColoringGridCollectionField.AdminOnly]: Boolean(category.isAdminOnly),
    },
  });

  const handleClick = handleSubmit((data: EditCollectionForms) => {
    edit({
      name: data.name?.trim(),
      isAdminOnly: Boolean(data.adminOnly),
    });

    reset();
    hideModal();

    toast.success(strings.toastNotificationAddCollection);
  });

  const closeModal = () => hideModal();

  return (
    <Modal height={500} onRequestClose={closeModal}>
      <Text style={{ marginTop: 40, fontWeight: 600 }} size={2}>
        {title}
      </Text>
      <FormWrapper>
        <Input
          required
          placeholder={strings.placeholderName}
          name={EditColoringGridCollectionField.Name}
          control={control}
          error={errors[EditColoringGridCollectionField.Name]}
          width="320px"
        />

        <AdminOnlyWrapper>
          <Input
            type="checkbox"
            placeholder={strings.adminOnly}
            name={EditColoringGridCollectionField.AdminOnly}
            control={control}
            error={errors[EditColoringGridCollectionField.AdminOnly]}
            width="30px"
            minWidth="30px"
            maxWidth="30px"
            marginBottom={10}
          />
          <Text style={{ marginBottom: 5 }} size={1}>
            {strings.adminOnly}
          </Text>
        </AdminOnlyWrapper>
        <Button
          style={{ marginTop: 10, marginLeft: 'auto', height: 40 }}
          width={140}
          onClick={handleClick}
        >
          {strings.submit}
        </Button>
      </FormWrapper>
    </Modal>
  );
};

export default EditColoringGridCollectionModal;
